<template>
  <div>
    <ValidationProvider rules="required" ref="topOffPlan" v-slot="{ errors }">
      <b-form class="needs-validation"
           >
        <b-row>
          <b-col xl="3" lg="3" sm="3">
            <p class="mt-3">
              <span class="h3">Type</span>
            </p>
          </b-col>
          <b-col xl="9" lg="9" sm="9">
            <b-form-group label-for="input-1">
              <b-form-select
                id="period"
                v-model="topOffPlanForm.type"
                :options="typeOption"
                :state="true"
                value-field="key"
                class="mt-2"
                text-field="label"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col xl="3" lg="3" sm="3">
            <p class="mt-3">
              <span class="h3">Name</span>
            </p>
          </b-col>
          <b-col xl="9" lg="9" sm="9">
            <b-form-group
              label-for="input-1"
            >
              <b-form-input
                id="input-1"
                :state="nameStatus"
                v-model="topOffPlanForm.name"
              ></b-form-input>
              <b-form-invalid-feedback :state="nameStatus">
                Please enter a valid name.
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col xl="3" lg="3" sm="3">
            <p class="mt-3">
              <span class="h3">Description</span>
            </p>
          </b-col>
          <b-col xl="9" lg="9" sm="9">
            <b-form-group
              label-for="input-1"
            >
              <b-form-input
                id="input-1"
                :state="descriptionStatus"
                v-model="topOffPlanForm.description"
              ></b-form-input>
              <b-form-invalid-feedback :state="descriptionStatus">
                Please enter valid description
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col xl="3" lg="3" sm="3">
            <p class="mt-3">
              <span class="h3">Price</span>
            </p>
          </b-col>
          <b-col xl="9" lg="9" sm="9">
            <b-form-group
              label-for="input-1"
            >
              <b-form-input
                id="input-1"
                :state="priceStatus"
                v-model="topOffPlanForm.price"
              ></b-form-input>
              <b-form-invalid-feedback :state="priceStatus">
                Please enter a valid price.
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col xl="3" lg="3" sm="3">
            <p class="mt-3">
              <span class="h3">Speed</span>
            </p>
          </b-col>
          <b-col xl="9" lg="9" sm="9">
            <b-form-group
              label-for="input-1"
            >
              <b-form-input
                id="input-1"
                :state="speedStatus"
                v-model="topOffPlanForm.speed"
              ></b-form-input>
              <b-form-invalid-feedback :state="speedStatus">
                Please enter a valid speed
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col xl="3" lg="3" sm="3">
            <p class="mt-3">
              <span class="h3">Quota</span>
            </p>
          </b-col>
          <b-col xl="9" lg="9" sm="9">
            <b-form-group
              label-for="input-1"
            >
              <b-form-input
                id="input-1"
                :state="quotaStatus"
                v-model="topOffPlanForm.quota"
              ></b-form-input>
              <b-form-invalid-feedback :state="quotaStatus">
                Please enter a valid quota.
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col xl="3" lg="3" sm="3">
            <p class="mt-3">
              <span class="h3">Expires</span>
            </p>
          </b-col>
          <b-col xl="9" lg="9" sm="9">
            <b-form-group
              label-for="input-1"
            >
              <b-form-input
                id="input-1"
                :state="expiresStatus"
                v-model="topOffPlanForm.expires"
              ></b-form-input>
              <b-form-invalid-feedback :state="expiresStatus">
                Please enter a valid expires.
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col xl="3" lg="3" sm="3">
            <p class="mt-3">
              <span class="h3">Amount</span>
            </p>
          </b-col>
          <b-col xl="9" lg="9" sm="9">
            <b-form-group
              label-for="input-1"
            >
              <b-form-input
                id="input-1"
                :state="amountStatus"
                v-model="topOffPlanForm.amount"
              ></b-form-input>
              <b-form-invalid-feedback :state="amountStatus">
                Please enter a valid amount.
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col xl="3" lg="3" sm="3">
            <p class="mt-3">
              <span class="h3">Units</span>
            </p>
          </b-col>
          <b-col xl="9" lg="9" sm="9">
            <b-form-group
              label-for="input-1"
            >
              <b-form-input
                id="input-1"
                :state="unitsStatus"
                v-model="topOffPlanForm.units"
              ></b-form-input>
              <b-form-invalid-feedback :state="unitsStatus">
                Please enter a valid uom.
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <hr>
        
        <div class="mt-3 d-flex justify-content-between">
          <base-button type="white" title="Close"  v-on:click="modalClose()">
                Close
              </base-button>
          <base-button type="primary" title="Search"  v-on:click="topPlanSubmit" :loading="submitLoading">
            Submit
          </base-button>
        </div>

      </b-form>
    </ValidationProvider>

  </div>
</template>

<script>
  import {ValidationProvider} from "vee-validate";
  import administratorService from "../../common/api-services/administrator-service";
  import handleResponse from "../../common/directive/handlResponse";

  export default {
    name: "create-topoff-plan",
    components: {
      ValidationProvider
    },
    computed: {
      nameStatus() {
        return this.topOffPlanForm.name.length > 0
      },
      descriptionStatus() {
        return this.topOffPlanForm.description.length > 0
      },
      priceStatus() {
        return this.topOffPlanForm.price.length > 0
      },
      speedStatus() {
        return this.topOffPlanForm.speed.length > 0
      },
      quotaStatus() {
        return this.topOffPlanForm.quota.length > 0
      },
      expiresStatus() {
        return this.topOffPlanForm.expires.length > 0
      },
      amountStatus() {
        return this.topOffPlanForm.amount.length > 0
      },
      unitsStatus() {
        return this.topOffPlanForm.units.length > 0
      },
    },
    data() {
      return {
        topOffPlanForm: {
          id: '',
          type: 'INT',
          name: '',
          description: '',
          price: '',
          speed: '',
          quota: '',
          expires: '',
          amount: '',
          units: ''
        },
        typeOption: [
          {key: 'INT', label: 'INT'},
          {key: 'CEL', label: 'CEL'}
        ],
        editStatus: false,
        submitLoading: false
      }
    },
    mounted() {
      this.$root.$on('editTopOffPlan', (res => {
        this.editStatus = res.status;
        this.fetchTopOffPlan(res.item)
      }))
    },
    methods: {
      fetchTopOffPlan(item) {
        this.topOffPlanForm.id = item.id;
        this.topOffPlanForm.type = item.type;
        this.topOffPlanForm.name = item.name;
        this.topOffPlanForm.description = item.description;
        this.topOffPlanForm.price = item.price;
        this.topOffPlanForm.speed = item.speed;
        this.topOffPlanForm.quota = item.quota;
        this.topOffPlanForm.expires = item.quota;
        this.topOffPlanForm.expires = item.expires;
        this.topOffPlanForm.amount = item.amount;
        this.topOffPlanForm.units = item.units;
      },

      modalClose() {
        this.$bvModal.hide('top-off-plan');
      },

      topPlanSubmit() {
        if (this.nameStatus && this.descriptionStatus && this.priceStatus && this.speedStatus && this.quotaStatus &&
          this.expiresStatus && this.amountStatus && this.unitsStatus) {
          this.submitLoading = true
          if (this.editStatus) {
            this.topOffPlanFunc(`editTopOffPlan&id=${this.topOffPlanForm.id}`)
          } else {
            this.topOffPlanFunc('addTopOffPlan');
          }
        }
      },

      topOffPlanFunc(method) {
        administratorService.addTopOffPlan(method, this.topOffPlanForm).then(res => {
          this.submitLoading = false;
          let {type, msg} = handleResponse.apiResponse(res);
          this.$toast(msg, {type: type})
          this.modalClose();
          this.$root.$emit('topOffPlanCall', true)
        })
      },
    }
  }
</script>

<style scoped>

</style>
